import React from "react";

const Footer = () => {
  return <div className="footer purple">Designed & Built by Matt Hastings</div>;
};

export default Footer;
